// extracted by mini-css-extract-plugin
export default {"container":"CreateTeam_container__moMDN"};